<template>
  <div class="single-post">
    <Transition name="loading-fade">
      <div v-if="loading" id="loading">
        <div class="loader"></div>
      </div>
    </Transition>
    <template v-if="!loading">
      <hero-section
        :title="getPageTitle"
        :text="htmldecode(pageContent.excerpt['rendered']) || null"
        :image="pageContent['_embedded']['wp:featuredmedia'][0].media_details.sizes['post-featured'].source_url || null" />
      <section class="single-post-section">
        <div class="container">
          <div class="sp-wrapper">
            <div class="sp-image">
              <img :src="pageContent['_embedded']['wp:featuredmedia'][0].source_url" :alt="getPageTitle" @click="toggleModal">
            </div>
            <div class="sp-content">
              <h6 class="cat" v-if="getAllCategories.main && getAllCategories.main.length"><b>{{ $t('category') }}: </b>{{ getAllCategories.main[0].name }}</h6>
              <h2>{{ getPageTitle }}</h2>
              <p class="cat" v-if="getAllCategories.years && getAllCategories.years.length"><b>{{ $t('year') }}: </b>{{ getAllCategories.years[0].name }}</p>
              <p class="cat" v-if="getAllCategories.phases && getAllCategories.phases.length"><b>{{ $t('phase') }}: </b>{{ getAllCategories.phases[0].name }}</p>
              <p class="cat" v-if="getAllCategories.materials && getAllCategories.materials.length"><b>{{ $t('material') }}: </b>{{ getAllCategories.materials[0].name }}</p>
              <div v-if="pageContent.content.rendered" v-html="pageContent.content.rendered"></div>
            </div>
          </div>
        </div>
      </section>
      <div class="modal-image" ref="modal" @keyup.esc="closeModal" tabindex="0">
        <span class="close" @click="closeModal">&times;</span>
        <img class="modal-content" :src="pageContent['_embedded']['wp:featuredmedia'][0].source_url" :alt="getPageTitle">
      </div>
    </template>
  </div>
</template>

<script>
  import HeroSection from '@/components/global/HeroSection.vue';
  export default {
    name: "SinglePost",
    components: {
      HeroSection,
    },
    computed: {
      pageContent() {
        return this.$store.getters['singlePostModule/getPageContent'];
      },
      getPageTitle() {
        return (this.pageContent.acf.hero_title && this.pageContent.acf.hero_title !== '') ? this.pageContent.acf.hero_title : this.pageContent.title.rendered;
      },
      getAllCategories() {
        const postType = this.$route.matched[1].name === 'artworks' ? 'artworks' : 'exhibitions';
        const mainCat = postType === 'artworks' ? this.$store.getters['postTypeModule/getArtworksCategories'] : this.$store.getters['postTypeModule/getExhibitionsCategories'];
        const phases = this.$store.getters['postTypeModule/getPhases'];
        const materials = this.$store.getters['postTypeModule/getMaterials'];
        const years = this.$store.getters['postTypeModule/getYears'];

        const allCategories = () => {
          let obj = {};
          obj['main'] = mainCat.filter((i) => {
            const catSlug = postType === 'artworks' ? 'artwork-categories' : 'exhibition-publication-categories';
            return i.id === this.pageContent[catSlug][0];
          });
          if(postType === 'artworks'){
            obj['phases'] = phases.filter((i) => {
              return i.id === this.pageContent['phases'][0];
            });
            obj['materials'] = materials.filter((i) => {
              return i.id === this.pageContent['materials'][0];
            });
            obj['years'] = years.filter((i) => {
              return i.id === this.pageContent['years'][0];
            });
          }
          return obj;
        }
        return allCategories();
      },
      loading() {
        return this.$store.getters['singlePostModule/getLoading'];
      },
    },
    methods: {
      getPageContent(postType, slug){
        this.$store.dispatch('singlePostModule/getPageContent', {
          postType,
          slug
        });
      },
      getCategories(postType, taxonomy = null){
        this.$store.dispatch('postTypeModule/getCategories', {
          postType,
          taxonomy
        });
      },
      htmldecode(s){
        window.HTML_ESC_MAP = {
        "nbsp":" ","iexcl":"¡","cent":"¢","pound":"£","curren":"¤","yen":"¥","brvbar":"¦","sect":"§","uml":"¨","copy":"©","ordf":"ª","laquo":"«","not":"¬","reg":"®","macr":"¯","deg":"°","plusmn":"±","sup2":"²","sup3":"³","acute":"´","micro":"µ","para":"¶","middot":"·","cedil":"¸","sup1":"¹","ordm":"º","raquo":"»","frac14":"¼","frac12":"½","frac34":"¾","iquest":"¿","Agrave":"À","Aacute":"Á","Acirc":"Â","Atilde":"Ã","Auml":"Ä","Aring":"Å","AElig":"Æ","Ccedil":"Ç","Egrave":"È","Eacute":"É","Ecirc":"Ê","Euml":"Ë","Igrave":"Ì","Iacute":"Í","Icirc":"Î","Iuml":"Ï","ETH":"Ð","Ntilde":"Ñ","Ograve":"Ò","Oacute":"Ó","Ocirc":"Ô","Otilde":"Õ","Ouml":"Ö","times":"×","Oslash":"Ø","Ugrave":"Ù","Uacute":"Ú","Ucirc":"Û","Uuml":"Ü","Yacute":"Ý","THORN":"Þ","szlig":"ß","agrave":"à","aacute":"á","acirc":"â","atilde":"ã","auml":"ä","aring":"å","aelig":"æ","ccedil":"ç","egrave":"è","eacute":"é","ecirc":"ê","euml":"ë","igrave":"ì","iacute":"í","icirc":"î","iuml":"ï","eth":"ð","ntilde":"ñ","ograve":"ò","oacute":"ó","ocirc":"ô","otilde":"õ","ouml":"ö","divide":"÷","oslash":"ø","ugrave":"ù","uacute":"ú","ucirc":"û","uuml":"ü","yacute":"ý","thorn":"þ","yuml":"ÿ","fnof":"ƒ","Alpha":"Α","Beta":"Β","Gamma":"Γ","Delta":"Δ","Epsilon":"Ε","Zeta":"Ζ","Eta":"Η","Theta":"Θ","Iota":"Ι","Kappa":"Κ","Lambda":"Λ","Mu":"Μ","Nu":"Ν","Xi":"Ξ","Omicron":"Ο","Pi":"Π","Rho":"Ρ","Sigma":"Σ","Tau":"Τ","Upsilon":"Υ","Phi":"Φ","Chi":"Χ","Psi":"Ψ","Omega":"Ω","alpha":"α","beta":"β","gamma":"γ","delta":"δ","epsilon":"ε","zeta":"ζ","eta":"η","theta":"θ","iota":"ι","kappa":"κ","lambda":"λ","mu":"μ","nu":"ν","xi":"ξ","omicron":"ο","pi":"π","rho":"ρ","sigmaf":"ς","sigma":"σ","tau":"τ","upsilon":"υ","phi":"φ","chi":"χ","psi":"ψ","omega":"ω","thetasym":"ϑ","upsih":"ϒ","piv":"ϖ","bull":"•","hellip":"…","prime":"′","Prime":"″","oline":"‾","frasl":"⁄","weierp":"℘","image":"ℑ","real":"ℜ","trade":"™","alefsym":"ℵ","larr":"←","uarr":"↑","rarr":"→","darr":"↓","harr":"↔","crarr":"↵","lArr":"⇐","uArr":"⇑","rArr":"⇒","dArr":"⇓","hArr":"⇔","forall":"∀","part":"∂","exist":"∃","empty":"∅","nabla":"∇","isin":"∈","notin":"∉","ni":"∋","prod":"∏","sum":"∑","minus":"−","lowast":"∗","radic":"√","prop":"∝","infin":"∞","ang":"∠","and":"∧","or":"∨","cap":"∩","cup":"∪","int":"∫","there4":"∴","sim":"∼","cong":"≅","asymp":"≈","ne":"≠","equiv":"≡","le":"≤","ge":"≥","sub":"⊂","sup":"⊃","nsub":"⊄","sube":"⊆","supe":"⊇","oplus":"⊕","otimes":"⊗","perp":"⊥","sdot":"⋅","lceil":"⌈","rceil":"⌉","lfloor":"⌊","rfloor":"⌋","lang":"〈","rang":"〉","loz":"◊","spades":"♠","clubs":"♣","hearts":"♥","diams":"♦","\"":"quot","amp":"&","lt":"<","gt":">","OElig":"Œ","oelig":"œ","Scaron":"Š","scaron":"š","Yuml":"Ÿ","circ":"ˆ","tilde":"˜","ndash":"–","mdash":"—","lsquo":"‘","rsquo":"’","sbquo":"‚","ldquo":"“","rdquo":"”","bdquo":"„","dagger":"†","Dagger":"‡","permil":"‰","lsaquo":"‹","rsaquo":"›","euro":"€"};
        if(!window.HTML_ESC_MAP_EXP)
            window.HTML_ESC_MAP_EXP = new RegExp("&("+Object.keys(window.HTML_ESC_MAP).join("|")+");","g");
        return s?s.replace(/(<([^>]+)>)/ig, '').replace(window.HTML_ESC_MAP_EXP,function(x){
            return window.HTML_ESC_MAP[x.substring(1,x.length-1)]||x;
        }):s;
      },
      toggleModal() {
        // Get the modal
        let modal = this.$refs.modal;
        modal.style.display = "block";
        modal.focus();
      },
      closeModal() {
        let modal = this.$refs.modal;
        modal.style.display = "none";
      }
    },
    created(){
      const postType = this.$route.matched[1].name === 'artworks' ? 'artworks' : 'exhibitions';
      const slug = this.$route.params.slug;
      this.getPageContent(postType, slug);
      this.getCategories(postType, null);
      this.getCategories('artworks', 'phases');
      this.getCategories('artworks', 'materials');
      this.getCategories('artworks', 'years');
    },
  }
</script>
<style scoped>
  .hero-section.small {
    min-height: 50vh;
  }
  .single-post-section {
    padding: 100px 0;
  }
  /* .single-post-section .sp-wrapper {
    display: flex;
    align-items: flex-start;
    gap: 80px;
  } */
  .single-post-section .sp-wrapper:after {
    content: "";
    clear: both;
    display: table;
  }
  .single-post-section .sp-image {
    float: left;    
    margin: 0 80px 80px 0;
    max-width: 600px;
    flex: 0 0 600px;
    width: 100%;
    position: relative;
    overflow: hidden;
    height: 0;
    padding-bottom: 600px;
  }
  .single-post-section .sp-image img {
    -o-object-fit: cover;
    object-fit: cover;
    -o-object-position: center;
    object-position: center;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    left: 50%;
    transition: 1.2s ease-in-out;
    cursor: pointer;
    width: 100%;
    height: 100%;
  }
  .single-post-section .sp-image:hover img {
    transform: translate(-50%, -50%) scale(1.08);
  }
  .single-post-section .sp-content .cat {
    text-transform: uppercase;
  }
  .modal-image {
    display: none; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 10000; /* Sit on top */
    padding-top: 100px; /* Location of the box */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0,0,0); /* Fallback color */
    background-color: rgba(0,0,0,0.9); /* Black w/ opacity */
    padding: 80px;
  }
  .modal-content {
    margin: auto;
    display: block;
    /* max-width: 80%; */
    /* max-height: 800px; */
    max-height: 100%;
    width: auto;
    height: auto;
  }
  @keyframes zoom {
    from {transform:scale(0)}
    to {transform:scale(1)}
  }
  /* The Close Button */
  .close {
    position: absolute;
    top: 15px;
    right: 35px;
    color: #f1f1f1;
    font-size: 40px;
    font-weight: bold;
    transition: 0.3s;
  }

  .close:hover,
  .close:focus {
    color: #bbb;
    text-decoration: none;
    cursor: pointer;
  }

  @media (max-width: 1199px){
    .single-post-section .sp-image {
      margin: 0 40px 40px 0;
    }
  }
  @media (max-width: 991px){
    .single-post-section .sp-image {
      float: none;
      margin: 0 0 50px 0;
      max-width: 100%;
      flex: 0 0 100%;
      padding-bottom: 100%;
    }
    .modal-image[data-v-fbb2ca7c] {
      padding: 80px 35px;
    }
    .single-post-section[data-v-fbb2ca7c] {
      padding: 80px 0;
    }
  }
  @media (max-width: 767px){
    .single-post-section[data-v-fbb2ca7c] {
      padding: 50px 0;
    }
  }
  /* 100% Image Width on Smaller Screens */
  @media only screen and (max-width: 700px){
    .modal-content {
      max-width: 100%;
    }
  }
</style>